<li class="m-select-item"
    :class="{ 'm--is-focus': focused && isItemActive,
              'm--is-selected': selected && isItemActive,
              'm--is-item-active': isItemActive,
              'm--is-disabled': disabled,
              'm--readonly': readonly,
              'm--without-radio': hideRadioButtonMobile }"
    role="option"
    :aria-selected="selected && isItemActive"
    @click.prevent="onClick">

    <slot v-if="isMqMinS || readonly || hideRadioButtonMobile"><span class="m-select-item__element-text">{{ label }}</span></slot>

    <m-radio-style :full-width="true"
                   radio-position="right"
                   :focus="focused"
                   :checked="selected"
                   :disabled="disabled"
                   tabindex="0"
                   v-else>

        <slot><span class="m-select-item__element-text">{{ label }}</span></slot>

    </m-radio-style>
</li>
